import type { CityConfig } from "../city-template/types";

export const asheboroConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — NC DHHS Vital Records", href: "https://vitalrecords.nc.gov/", description: "Official North Carolina vital records office in Raleigh" },
    { label: "Marriage Licenses — Randolph County Register of Deeds", href: "https://www.randolphcountync.gov/", description: "Randolph County Register of Deeds — marriage license issuance" },
    { label: "Divorce Records — Randolph County Clerk of Court", href: "https://www.randolphcountync.gov/", description: "Randolph County Clerk of Court — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of NC DHHS for online vital record orders" },
  ],
  city: "Asheboro",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "asheboro",
  route: "/asheboro",
  title: "Emergency Passport Asheboro, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Asheboro, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Randolph County and the Piedmont Triad. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Asheboro, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Asheboro and Randolph County travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Asheboro%20North%20Carolina%20scenic%20downtown%20view%20at%20golden%20hour%20with%20historic%20architecture%20and%20the%20Uwharrie%20National%20Forest%20foothills%20in%20the%20background%2C%20charming%20small%20town%20American%20atmosphere%20with%20tree-lined%20streets%2C%20warm%20sunset%20light%20over%20Randolph%20County%2C%20green%20trees%20and%20well-maintained%20storefronts%2C%20rolling%20Piedmont%20hills%20visible%2C%20professional%20cityscape%20photography%20with%20warm%20earthy%20tones%20and%20southern%20small%20town%20charm%2C%20no%20text%20or%20signs%20on%20buildings&width=1800&height=700&seq=asheboro-hero-nc-001&orientation=landscape",
  heroImageAlt: "Asheboro North Carolina scenic downtown with historic architecture and Uwharrie foothills at golden hour",
  geoPosition: "35.7079;-79.8136",
  geoPlacename: "Asheboro, North Carolina",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree Street NW, Suite 1400, Atlanta, GA 30303",
    distance: "Located in downtown Atlanta — approximately 280 miles from Asheboro via I-85",
  },
  nearbyCitiesZips: [
    { name: "Asheboro", zips: "27203, 27204, 27205" },
    { name: "High Point", zips: "27260, 27261, 27262, 27263, 27265" },
    { name: "Greensboro", zips: "27401–27499" },
    { name: "Winston-Salem", zips: "27101–27199" },
    { name: "Thomasville", zips: "27360, 27361" },
    { name: "Archdale", zips: "27263" },
    { name: "Lexington", zips: "27292, 27293, 27295" },
    { name: "Randleman", zips: "27317" },
    { name: "Trinity", zips: "27370" },
    { name: "Kernersville", zips: "27284, 27285" },
    { name: "Burlington", zips: "27215, 27216, 27217" },
    { name: "Reidsville", zips: "27320, 27323" },
    { name: "Eden", zips: "27288, 27289" },
    { name: "Graham", zips: "27253" },
    { name: "Mebane", zips: "27302" },
    { name: "Charlotte", zips: "28201–28299" },
    { name: "Concord", zips: "28025, 28026, 28027" },
    { name: "Kannapolis", zips: "28081, 28082, 28083" },
    { name: "Salisbury", zips: "28144, 28145, 28146, 28147" },
    { name: "Albemarle", zips: "28001, 28002" },
    { name: "Raleigh", zips: "27601–27699" },
    { name: "Durham", zips: "27701–27717" },
    { name: "Chapel Hill", zips: "27514, 27516, 27517" },
    { name: "Sanford", zips: "27330, 27332" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Randolph County departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "Randolph County Hub", desc: "Serving Asheboro, High Point, Greensboro, and the Piedmont Triad" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Greensboro, NC", route: "/greensboro" },
    { name: "Fast passport renewal in High Point, NC", route: "/high-point" },
    { name: "Emergency passport help in Winston-Salem, NC", route: "/winston-salem" },
    { name: "Urgent passport services in Charlotte, NC", route: "/charlotte" },
    { name: "Same-day passport help in Raleigh, NC", route: "/raleigh" },
    { name: "Passport courier services in Durham, NC", route: "/durham" },
    { name: "Passport courier services in Burlington, NC", route: "/burlington" },
    { name: "Fast passport renewal in Salisbury, NC", route: "/salisbury" },
    { name: "Expedited passport services in Thomasville, NC", route: "/thomasville" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Asheboro remotely via secure courier. We do not have a walk-in office in Asheboro — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Randolph County and the Piedmont Triad travelers.",
  fpcOfficeAddress: "301 S McDowell St, Charlotte, North Carolina 28204",
  fpcOfficeDistance: "Serving all of Randolph County and the Piedmont Triad including Guilford, Forsyth, Alamance, and Davidson counties",
  serviceAreaIntro: "From the historic downtown of Asheboro to the furniture markets of High Point, from the bustling streets of Greensboro to the quiet communities of Thomasville and Archdale, from the Uwharrie foothills to the rolling Piedmont, from the university corridors of Winston-Salem to the Charlotte metro, from the Durham-Chapel Hill axis to the Sandhills of Sanford — Fast Passport Center serves the entire Asheboro region. We regularly help travelers from Randolph County, the Piedmont Triad, and central North Carolina get their passports fast.",
  nearbyCitiesIntro: "We serve all Asheboro neighborhoods and the surrounding Randolph County and Piedmont Triad area including High Point, Greensboro, Winston-Salem, Thomasville, Archdale, Lexington, Randleman, Trinity, Kernersville, Burlington, Reidsville, Eden, Graham, Mebane, Charlotte, Concord, Kannapolis, Salisbury, Albemarle, Raleigh, Durham, Chapel Hill, and Sanford. If you are anywhere in Randolph County, the Piedmont Triad, or central North Carolina, we have you covered.",
  howItWorksIntro: "Most Asheboro travelers complete everything online and ship documents overnight. No need to drive to Atlanta or wait in line at the regional agency.",
  mistakesIntro: "Asheboro travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Asheboro and Randolph County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Asheboro? Here are the most common ones we hear from Randolph County and Piedmont Triad travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Asheboro international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Jennifer R.",
      location: "Asheboro, NC",
      rating: 5,
      text: "My passport expired 4 days before our family trip to Mexico. Fast Passport Center had my renewal ready in 30 hours. I never left Asheboro. Their expedited passport service was outstanding.",
      service: "Passport Renewal",
    },
    {
      name: "Michael D.",
      location: "Thomasville, NC",
      rating: 5,
      text: "Emergency passport for a business trip to Germany. Got it in 26 hours. Fast Passport Center handled everything — I didn't have to drive to Atlanta. Their fast passport service is incredible.",
      service: "Emergency Passport",
    },
    {
      name: "Susan M.",
      location: "Archdale, NC",
      rating: 5,
      text: "First passport for my 10-year-old before our Europe trip. Fast Passport Center walked us through every step and had her passport in 4 days. So easy for Randolph County families.",
      service: "Child Passport",
    },
    {
      name: "David K.",
      location: "High Point, NC",
      rating: 5,
      text: "Lost my passport 3 days before a cruise. Fast Passport Center had a replacement in my hands in 28 hours. Their expedited passport service across the Triad is unmatched.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "asheboro-1",
      name: "Asheboro Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "315 E Salisbury St",
      city: "Asheboro",
      state: "NC",
      zip: "27203",
      phone: "(336) 626-4121",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Asheboro",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Asheboro facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "asheboro-2",
      name: "High Point Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1353 N Main St",
      city: "High Point",
      state: "NC",
      zip: "27262",
      phone: "(336) 882-8124",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "25 miles northeast of Asheboro",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Major regional facility for the Piedmont Triad. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "asheboro-3",
      name: "Greensboro Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 N Murrow Blvd",
      city: "Greensboro",
      state: "NC",
      zip: "27401",
      phone: "(336) 373-7825",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "30 miles north of Asheboro",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Guilford County and north Randolph County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "asheboro-4",
      name: "Thomasville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "10 Salem St",
      city: "Thomasville",
      state: "NC",
      zip: "27360",
      phone: "(336) 472-2381",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "15 miles east of Asheboro",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Davidson County and east Randolph County. Call for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "asheboro-5",
      name: "Randolph County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "176 E Salisbury St",
      city: "Asheboro",
      state: "NC",
      zip: "27203",
      phone: "(336) 683-8000",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Downtown Asheboro, Courthouse",
      website: "https://www.randolphcountync.gov/",
      websiteLabel: "Randolph County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "asheboro-6",
      name: "Lexington Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "135 W 1st St",
      city: "Lexington",
      state: "NC",
      zip: "27292",
      phone: "(336) 249-8381",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "20 miles west of Asheboro",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Davidson County and west Randolph County. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 4.5 hour drive to Atlanta", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Asheboro photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Randolph County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Asheboro applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Randolph County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Asheboro travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Asheboro." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Asheboro address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Asheboro before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Asheboro for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 4.5 hour drive to Atlanta." },
    { q: "How fast can I renew my passport in Asheboro?", a: "Fast Passport Center offers fast passport renewal in Asheboro in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Asheboro?", a: "The nearest regional passport agency to Asheboro is the Atlanta Passport Agency, approximately 280 miles away via I-85. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Asheboro without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Asheboro?", a: "Same-day passport appointments are only available at the Atlanta Regional Passport Agency — approximately 4.5 hours from Asheboro — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Randolph County and Piedmont Triad residents." },
    { q: "Do you serve the entire Randolph County area?", a: "Absolutely. Fast Passport Center serves the entire Randolph County and Piedmont Triad area including Asheboro, High Point, Greensboro, Winston-Salem, Thomasville, Archdale, Lexington, Randleman, Trinity, Kernersville, Burlington, Reidsville, Eden, Graham, Mebane, Charlotte, Concord, Kannapolis, Salisbury, Albemarle, Raleigh, Durham, Chapel Hill, and Sanford. Our courier service works seamlessly from any address in Randolph County and surrounding areas." },
    { q: "Can I expedite a child passport in Asheboro?", a: "Yes. Fast Passport Center expedites child passports in Asheboro for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Randolph County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Asheboro with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Atlanta Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Asheboro", address: "315 E Salisbury St, Asheboro, NC 27203", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Asheboro", address: "1121 E Dixie Dr, Asheboro, NC 27203", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "Walmart Supercenter — Asheboro", address: "1220 E Dixie Dr, Asheboro, NC 27203", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "CVS Pharmacy — High Point", address: "2630 N Main St, High Point, NC 27265", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Greensboro", address: "2504 Battleground Ave, Greensboro, NC 27408", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Thomasville", address: "1112 Randolph St, Thomasville, NC 27360", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Lexington", address: "1620 N Main St, Lexington, NC 27292", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "FedEx Office — Greensboro", address: "3302 W Friendly Ave, Greensboro, NC 27410", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
  ],
  dmvLocations: [
    {
      name: "NC DMV — Asheboro",
      address: "1633 E Dixie Dr, Asheboro, NC 27203",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "NC DMV — High Point",
      address: "4620 W Market St, Greensboro, NC 27407",
      hours: "Mon–Fri: 8AM–5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "NC DMV — Greensboro",
      address: "3411 W Wendover Ave, Greensboro, NC 27407",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Guilford County and the Greensboro area. REAL ID available.",
      featured: false,
    },
    {
      name: "NC DMV — Lexington",
      address: "824 S Talbert Blvd, Lexington, NC 27292",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Davidson County and southern Triad. REAL ID available.",
      featured: true,
    },
  ],
  airports: [
    {
      code: "GSO",
      name: "Piedmont Triad International Airport",
      distance: "45 miles north of Asheboro",
      address: "1000 Ted Johnson Pkwy, Greensboro, NC 27409",
      note: "Primary airport for the Piedmont Triad region. Direct flights to major domestic destinations with seasonal international routes. About 50 minutes from Asheboro.",
      flightUrl: "https://www.flyfrompti.com/",
      flightLabel: "GSO Airport",
      featured: true,
    },
    {
      code: "RDU",
      name: "Raleigh-Durham International Airport",
      distance: "70 miles east of Asheboro",
      address: "2400 John Brantley Blvd, Morrisville, NC 27560",
      note: "Major international airport for the Research Triangle. Direct flights to London, Paris, Cancun, Toronto, and major domestic destinations. Consider for long-haul international travel.",
      flightUrl: "https://www.rdu.com/",
      flightLabel: "RDU Airport",
      featured: false,
    },
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "75 miles southwest of Asheboro",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major international hub. American Airlines hub with direct flights to Europe, Mexico, and the Caribbean. Consider for international travel from Randolph County.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: false,
    },
  ],
};